import { QueueEvent } from '..';
import { PlaceCallPayload } from '../types/types';

// =============================================================================
// HELPER TYPES AND UTILITIES
// =============================================================================

// Type-safe event creators
export const createPlaceCallEvent = (
  payload: Omit<PlaceCallPayload, 'type'>
): Omit<QueueEvent<PlaceCallPayload>, 'id' | 'timestamp' | 'channel'> => ({
  payload: {
    type: 'place-call',
    ...payload,
  },
});

// Type guard functions
export const isCallInitiatedEvent = (event: QueueEvent): event is QueueEvent<PlaceCallPayload> =>
  event.payload.type === 'place-call';
